import { attachedFileFragment } from '@reconcept-platform/shared/data-access';
import { gql } from 'apollo-angular';

export const CommentAttachmentsQuery = gql`
  query CommentAttachmentsQuery($id: ID!) {
    node(id: $id) {
      ... on CardComment {
        id
        attachedFiles {
          ...AttachedFile
        }
      }
    }
  }
  ${attachedFileFragment}
`;
